import { testimonials } from "@/mocks/categories";

export default function Testimonials() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-3 h-3 rounded-full bg-accent-500"></span>
            <span className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-wider">
              Trusted by Buyers
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-[1.05] tracking-tight">
            Real Reviews<span className="block text-accent-500">Real Shoppers</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={t.name}
              className={`bg-background-100 rounded-xl p-5 md:p-6 ${
                testimonials.length - 1 === idx ? "opacity-60" : ""
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </span>
                ))}
              </div>
              <h4 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2 whitespace-nowrap">
                {t.title}
              </h4>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-4">
                {t.content}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                  <span className="text-xs font-bold text-secondary-700">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-xs md:text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-400 whitespace-nowrap">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}